import React, { useState } from 'react';
import Input from 'src/components/ui/Input/Input';
import Button, { ButtonToneProps } from 'src/components/ui/Button/Button';
import { useTranslation } from 'react-i18next';
import Modal from '../../layouts/Modal/Modal';

import styles from './SaveSearchModal.module.scss';

export type AddWidgetModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (name: string) => void;
};

const SaveSearchModal: React.FC<AddWidgetModalProps> = ({ isOpen, onClose, onSubmit }) => {
  const { t } = useTranslation();
  const [filterName, setFilterName] = useState('');
  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilterName(e.target.value);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className={styles.root}>
        <div className={styles.head}>
          <span className="py-6 flex justify-center">Suche speichern</span>
        </div>
        <div className={styles.content}>
          <Input value={filterName} placeholder="" label="Titel" onChange={handleTitleChange} />
          <span className="typo-text-12 text-faded mt-8">{t('general.filter_name')}</span>
        </div>
        <div className={styles.actions}>
          <Button onClick={onClose} tone={ButtonToneProps.SECONDARY} title={t('general.cancel')} />
          <Button onClick={() => onSubmit(filterName)} tone={ButtonToneProps.PRIMARY_BLUE} title={t('general.save')} />
        </div>
      </div>
    </Modal>
  );
};

export default SaveSearchModal;
